var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('h3',{staticClass:"table-header"},[_vm._v("Ballotpedia API4")]),_c('h3',{staticClass:"logout pull-right",on:{"click":_vm.logout}},[_c('i',{staticClass:"vsm-icon fa fa-sign-out-alt"}),_vm._v(" Logout")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }